import React from 'react';

import {
  Group,
  Spacing,
} from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import about from './../../../../../images/desktop/about.png';
import styles from './DesktopAboutUs.module.css';
import { DesktopAboutUsProps } from './types';
import { HorizontalSlides } from '../../../../../components/HorizontalSlides';

export const DesktopAboutUs: React.FC<DesktopAboutUsProps> = ({
  pagesOptions
}) => {

  return (
    <div>
      <Group className={styles.container} separator="hide">
        <AnimatePresence>
          <motion.div animate={{ scale: [1, 1.02, 1] }} transition={{ duration: 0.3 }}>
            <img style={{ width: '100%' }} src={about} alt=''/>
          </motion.div>
        </AnimatePresence>
        <Spacing size={20} />
        <HorizontalSlides pagesOptions={pagesOptions}/>
      </Group>
    </div>
  );
};
